<template>

  <span>
    {{ get_msg() }}
  </span>

</template>

<script>

export default{

  props: {settings: Object},

  methods: {

    get_msg () {
      if (typeof this.settings !== 'object' || typeof this.settings.id === 'undefined') { return {msg: ''} }

      var func = this.settings.id

      return this[func]()
    },
    get_user_boards () {
      if (!this.$store.getters.boards) { return 0 }

      return this.$store.getters.boards.length
    },

    get_user_limits () {
  		return this.$store.getters.board_limits[this.$store.getters.user.membership]
    },
    get_board_limits () {
      var limit = false

      if (limit = this.get_user_limits()) { return this.get_user_boards() + '/' + limit }

      return this.get_user_boards()
    }
  }

}

</script>
